import removeAriaLiveLabel from '../actions/removeAriaLiveLabel';
import { getAccessibilityStore } from '../store/Store';
import { mutator } from 'satcheljs';

export default mutator(
    removeAriaLiveLabel,
    function removeAriaLiveLabelMutator(actionMessage: { ariaLiveLabel: string }) {
        const { ariaLiveLabel } = actionMessage;
        const { ariaLiveLabels } = getAccessibilityStore();

        if (ariaLiveLabel && ariaLiveLabels.has(ariaLiveLabel)) {
            // remove the entry if the entry exists only
            ariaLiveLabels.delete(ariaLiveLabel);
        }
    }
);
